import React from 'react';
import { useLang } from '../contexts/LanguageContext';
import PageBanner from '../components/PageBanner';
import Contact from '../components/Contact';

const ContactPage = () => {
  const { t } = useLang();
  return (
    <>
      <PageBanner tag={t.contact.tag} title={t.contact.title} subtitle={t.contact.subtitle} />
      <Contact hideHeader />
    </>
  );
};

export default ContactPage;
